import { Ed25519KeyIdentity } from '@dfinity/identity'
import { JsonableSecp256k1Identity, Secp256k1KeyIdentity } from '@dfinity/identity-secp256k1'
import { Principal } from '@dfinity/principal'
import { v4 as uuidv4 } from 'uuid'

export interface SerializedWallet {
  offset: number
  uuid: string
  serializedIdentity: JsonableSecp256k1Identity
}

class Wallet {
  uuid: string
  offset: number
  identity: Ed25519KeyIdentity | Secp256k1KeyIdentity

  principal: Principal

  constructor(offset: number, identity: Ed25519KeyIdentity | Secp256k1KeyIdentity, uuid?: string) {
    this.offset = offset
    this.identity = identity

    this.principal = identity.getPrincipal()
    this.uuid = uuid || uuidv4()
  }

  static fromSerialized({ offset, serializedIdentity, uuid }: SerializedWallet) {
    const identity = Secp256k1KeyIdentity.fromParsedJson(serializedIdentity)

    return new Wallet(offset, identity, uuid)
  }

  serialize(): SerializedWallet {
    return {
      offset: this.offset,
      uuid: this.uuid,
      serializedIdentity: this.identity.toJSON(),
    }
  }
}

export default Wallet
